import React, { Fragment, Component } from "react";
import { Head, withSiteData } from "react-static";

import NewFooter from "../../blocks/NewFooter/NewFooterV2";
import DemoForm from "../../components/site/Forms/DemoForm";
import LazyYouTube from "../../components/LazyYouTube/LazyYouTube";
import StatsStrip from "../../components/site/StatsStripV6/StatsStripV6";
import NewMenu from "../../blocks/Menu/NewMenu";
import HomeSolutionsTabsV6 from "../../blocks/HomeSolutionsTabs/HomeSolutionsTabsV6Test";

import IndustriesAndDistributors from "../../blocks/TwoCols/IndustriesAndDistributorsTest";
import CommercialReps from "../../blocks/TwoCols/CommercialRepsV6";
import ClientLogosSlider from "../../blocks/TwoCols/ClientLogosSliderTest";
import TestimonialsVideoCardsV5 from "../../blocks/Testimonials/TestimonialsVideoCardsV5Test";
import FinalCTACard from "../../blocks/CardFooter/FinalCTACard";
import FAQV6, { FAQV6_SCHEMA } from "../../blocks/FAQ/FAQV6Test";
import CardsEstrategiasHomeV2 from "../../blocks/CardsEstrategias/CardsEstrategiasHomeV2";
import CompoundTitle from "../../components/experience/CompoundTitle/CompoundTitle";

import "./NewHomev6Test.scss";

const videoObjectSchema = {
  "@context": "https://schema.org",
  "@type": "VideoObject",
  "name": "Mercos: o sistema de vendas completo para indústrias, distribuidoras e representantes",
  "description": "Conheça o Mercos, sistema de vendas líder de mercado feito para indústrias, distribuidoras e representantes. O vídeo apresenta a jornada comercial completa da plataforma: CRM com gestão de carteira, prospecção, roteiro de visitas e histórico de clientes; Força de Vendas com aplicativo para emissão de pedidos offline, inteligência artificial e automações; E-commerce B2B para escalar operações com catálogo personalizado, preços e condições por cliente; além de múltiplas integrações com ERP, Mercos Pay e mais de 25 relatórios e indicadores. Tudo integrado em um único sistema, sem complicação.",
  "thumbnailUrl": [
    "https://img.youtube.com/vi/6M5mFpZTxII/maxresdefault.jpg"
  ],
  "uploadDate": "2026-04-09T19:00:00-03:00",
  "duration": "PT2M42S",
  "contentUrl": "https://www.youtube.com/watch?v=6M5mFpZTxII",
  "embedUrl": "https://www.youtube.com/embed/6M5mFpZTxII",
  "url": "https://mercos.com/",
  "inLanguage": "pt-BR",
  "keywords": [
    "sistema de vendas",
    "CRM de vendas",
    "força de vendas",
    "e-commerce B2B",
    "automação de vendas"
  ],
  "about": {
    "@type": "SoftwareApplication",
    "name": "Mercos",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web, Android, iOS",
    "url": "https://mercos.com/"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Mercos",
    "url": "https://www.mercos.com/",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mercos.com/images/site/logo-mercos-colored.svg"
    }
  },
  "author": {
    "@type": "Organization",
    "name": "Mercos",
    "url": "https://www.mercos.com/"
  },
  "copyrightHolder": {
    "@type": "Organization",
    "name": "Mercos"
  },
  "isFamilyFriendly": true,
  "potentialAction": {
    "@type": "WatchAction",
    "target": "https://www.youtube.com/watch?v=6M5mFpZTxII"
  }
};

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://mercos.com/#organization",
  "name": "Mercos",
  "description": "Mercos é o sistema de venda que reúne, em um só lugar: IA, automação de pedidos, gestão, CRM, e-commerce B2B, solução de pagamento e integração com ERPs.",
  "taxID": "12.496.510/0001-80",
  "email": "contato@mercos.com",
  "telephone": "(47) 3481-8050",
  "logo": "https://simplest-marketing.s3.amazonaws.com/imagens/logo-mercos-colored.png",
  "url": "https://mercos.com/",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Joinville",
    "addressRegion": "Santa Catarina",
    "postalCode": "89223-005",
    "streetAddress": "Av. Rolf Wiest, 277",
    "addressCountry": {
      "@type": "Country",
      "name": "BR"
    }
  }
};

class NewHomev6 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuVisible: true,
    };

    // Initialize scroll direction tracking
    this.scrollDirection = {
      lastScrollTop: 0,
      isScrollingDown: false,
    };
  }

  handleScroll = () => {
    // If mobile menu is open, do not hide the nav bar
    if (document.body.classList.contains("mobile-menu-is-open")) {
      return;
    }

    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Detect scroll direction (with small threshold to avoid jitter)
    if (Math.abs(currentScrollTop - this.scrollDirection.lastScrollTop) > 5) {
      this.scrollDirection.isScrollingDown = currentScrollTop > this.scrollDirection.lastScrollTop;
      this.scrollDirection.lastScrollTop = currentScrollTop;

      // Update menu visibility based on scroll direction
      // Hide menu when scrolling down after leaving top, show when scrolling up
      const menuVisible = currentScrollTop <= 100 || !this.scrollDirection.isScrollingDown;
      this.setState({ menuVisible });
    }
  };

  componentDidMount() {
    // Add scroll listener for menu hide/show
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  render() {
    const { menuVisible } = this.state;
    return (
      <Fragment>
        <div className={`new-home new-home-v3 new-home-v6-preview new-layout`}>
          <NewMenu transparentOnTop pixelsToShowMenuWhite={50} mutableMenu hideOnScroll menuVisible={menuVisible} />
          <Head>
            <title>Mercos: sistema de vendas n°1 que atua da prospecção ao pós-venda</title>
            <meta name="description" content="Mercos é o sistema de venda que reúne, em um só lugar: IA, automação de pedidos, gestão, CRM, e-commerce B2B, solução de pagamento e integração com ERPs" />
            <meta property="og:title" content="Mercos: sistema de vendas n°1 que atua da prospecção ao pós-venda" />
            <meta property="og:description" content="Mercos é o sistema de venda que reúne, em um só lugar: IA, automação de pedidos, gestão, CRM, e-commerce B2B, solução de pagamento e integração com ERPs" />
            <meta name="twitter:title" content="Mercos: sistema de vendas n°1 que atua da prospecção ao pós-venda" />
            <meta name="twitter:description" content="Mercos é o sistema de venda que reúne, em um só lugar: IA, automação de pedidos, gestão, CRM, e-commerce B2B, solução de pagamento e integração com ERPs" />
            <link rel="canonical" href="https://mercos.com" />
            <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
            <script type="application/ld+json">{JSON.stringify(videoObjectSchema)}</script>
            <script type="application/ld+json">{JSON.stringify(FAQV6_SCHEMA)}</script>
          </Head>

          {/* Hero Section */}
          <section className="hero-section-v6">
            <div className="container">
              <div className="hero-content">
                <h1 className="hero-title">
                  O sistema de vendas <span className="gradient-text">líder</span> para Indústrias, Distribuidoras e Representantes
                </h1>

                <h2 className="hero-description">
                  Descubra a plataforma que reúne Inteligência Artificial, automação de pedidos, gestão de vendas e produtos, CRM, e-commerce B2B, solução de pagamentos e integração com ERP: tudo em um só lugar
                </h2>

                <div className="hero-cta">
                  <DemoForm />
                </div>
              </div>

              <div className="hero-video">
                <LazyYouTube
                  videoId="6M5mFpZTxII"
                  coverImage="/images/site/new-home/v6/hero-video.png"
                  title="Video institucional Mercos"
                  width={980}
                  height={551}
                  playerParams="rel=0&modestbranding=1&playsinline=1"
                  useNoCookie
                />
              </div>
            </div>
          </section>

          {/* Results/Metrics */}
          <section className="results-section-v6">
            <StatsStrip />
          </section>

          <section className="results-logos-section-v6">
            <div className="container">
              <ClientLogosSlider className="home-results-logos-slider" />
            </div>
          </section>

          {/* Solutions Tabs Section (replaces PowerOfAI + AppRatings in v6) */}
          <section className="solutions-tabs-section-v6">
            <HomeSolutionsTabsV6 />
          </section>

          {/* Single Title Section */}
          <section className="single-title-section-v6">
            <div className="container">
              <CompoundTitle center tag="h3">
                Para quem é o sistema de vendas da Mercos?
              </CompoundTitle>
            </div>
          </section>

          {/* Mercos para Indústrias e Distribuidoras */}
          <section className="industries-distributors-section-v6 accordion-section-v6">
            <IndustriesAndDistributors
              imageSrc="/images/site/new-home/v6/section-industries-distributors.png"
              imageAlt='Sistema Mercos na aba de políticas comerciais, mostrando como a gestão de uma indústria ou distribuidora pode criar regras comerciais personalizadas para as necessidades da operação. A tela exibe o botão "nova condição de pagamento", políticas já criadas com valor mínimo, forma de pagamento e número de parcelas, além de opções de navegação para indicadores, funis de vendas, pedidos, clientes, produtos, e-commerce B2B, tarefas e Mercos IA.'
              titleTag="h4"
            />
          </section>

          {/* Mercos para Representantes */}
          <section className="commercial-reps-section-v6 accordion-section-v6">
            <CommercialReps
              imageSrc="/images/site/new-home/v6/section-representatives.png"
              imageAlt='Celular mostrando a Mercos IA, a inteligência artificial da Mercos, capaz de criar pedidos, responder perguntas sobre a operação comercial de uma indústria, distribuidora ou equipe de vendas e trazer insights valiosos para a gestão comercial e representação. Na tela aparecem sugestões de perguntas, como "como estão minhas vendas este mês?", "qual é o ranking de vendedores?", "quais são meus principais clientes?" e "qual o valor vendido por estado do cliente ABC?", além de exemplos de ações, como marcar um pedido como vendido e emitir um pedido.'
              featureCopy={[
                {
                  title: "App de vendas com IA",
                  description: "Emita pedidos com IA de qualquer lugar pelo celular ou tablet, mesmo offline (Android e iOS)",
                },
                {
                  title: "E-commerce para representantes",
                  description: "Destaque seus produtos por representada, com as condições específicas de cada cliente",
                },
                {
                  title: "CRM diretamente no WhatsApp",
                  description: "Consulte informações dos clientes, como histórico e pedidos, sem sair da conversa",
                },
                {
                  title: "Agenda e Roteirização",
                  description: "Planeje visitas e organize o tempo de trabalho, otimizando deslocamento e produtividade",
                },
              ]}
              titleTag="h4"
            />
          </section>

          {/* Strategies/Blog Cards */}
          <section className="strategies-section-v6">
            <CardsEstrategiasHomeV2
              titleTag="h3"
cards={[
                {
                  imgSrc: "/images/site/new-home/update/solucoes-ia.png",
                  imgAlt: "Homem sorrindo e olhando para o celular, feliz por atender o cliente com as soluções com IA da Mercos. Ao seu lado aparece, com zoom na tela, que ele faturou um pedido com facilidade.",
                  title: (
                    <span className="ia-card-title">
                      Soluções com IA
                      <img
                        src="/images/site/recursos/sparkle.svg"
                        alt=""
                        aria-hidden="true"
                        className="ia-card-title-sparkle"
                      />
                    </span>
                  ),
                  description: "Com o Mercos IA, você automatiza pedidos, responde dúvidas pelo WhatsApp, cria indicadores, resume históricos e acelera decisões",
                  link: '/recursos/mercos-ia/',
                },
                {
                  imgSrc: "/images/site/new-home/update/suporte.png",
                  imgAlt: 'Imagem do chat em tempo real do sistema de vendas, mostrando a pergunta "Olá, estou com uma dúvida, pode me ajudar?" e a resposta "Claro! Como posso lhe ajudar?"',
                  title: <Fragment>Suporte<br /> em tempo real</Fragment>,
                  description: "Respondemos em até 20 segundos no chat e WhatsApp ou por telefone e e-mail, em horário comercial",
                },
                {
                  imgSrc: "/images/site/new-home/update/indicadores.png",
                  imgAlt: 'Imagem de alguns exemplos de indicadores em um sistema de vendas. Em foco, é possível ver "Top clientes", "Positivação de Clientes", "Curva ABC de Clientes", "Painel financeiro", com bonificação e "Faturamento", todos disponíveis na aba "Indicadores" do Mercos',
                  title: <Fragment>Indicadores<br /> personalizáveis</Fragment>,
                  description: "Acesse +25 indicadores prontos ou crie qualquer indicador com IA, com segurança e confiabilidade",
                  link: '/recursos/indicadores-performance/',
                },
                {
                  imgSrc: "/images/site/new-home/update/apoio.png",
                  imgAlt: "Tela com código representando a tecnologia e a automação de vendas B2B para indústrias e distribuidoras, com apoio para a equipe de TI.",
                  title: <Fragment>Apoio integral para<br /> sua equipe de TI</Fragment>,
                  description: "Equipe profissional e preparada para tirar dúvidas do time de TI",
                },
                {
                  imgSrc: "/images/site/new-home/update/mercos-pay.png",
                  imgAlt: 'Imagem de um pedido feito na solução de pagamentos Mercos Pay. É possível ver que o comprador montou um carrinho, passou pela etapa de entrega e agora está na etapa de pagamento. A imagem mostra um pagamento sendo feito por boleto bancário, com quantidade de parcelas e detalhes do parcelamento.',
                  title: "Mercos Pay",
                  description: "A solução de pagamentos da Mercos permite recebimentos por cartão, boleto, link de pagamento ou Pix, direto do sistema",
                  link: '/mercos-pay/',
                },
                {
                  imgSrc: "/images/site/new-home/update/e-commerce.png",
                  imgAlt: 'Imagem do E-commerce B2B Mercos com Videochamada, mostrando um site que vende canecas B2B, ou seja, para outras empresas. É possível ver uma caneca preta com a base bege, outra caneca preta com o topo cinza e uma jarra preta com cabo bege à venda, para que os clientes comprem diretamente do site, com o vendedor podendo acompanhar de perto por vídeo.',
                  title: <Fragment>E-commerce B2B<br /> com Videochamada</Fragment>,
                  description: "Clientes compram e tiram dúvidas online com os vendedores, com uma experiência próxima do atendimento presencial",
                  link: '/e-commerce-b2b/',
                },
              ]}
            />
          </section>
          {/* Testimonials V6 Section */}
          <section className="testimonials-section-v6">
            <TestimonialsVideoCardsV5
              showClientLogos={false}
              customTestimonials={[
                {
                  testimonial: <Fragment>"Com o Mercos, os vendedores geram orçamentos e emitem pedidos sem complicação e sem controles manuais. Isso reduz erros, economiza tempo e acaba com a necessidade de levar trabalho para casa, já que o sistema resolve tudo na hora"</Fragment>,
                  author: "Mauricio Perin",
                  company: "Flach Equipamentos Inteligentes",
                  stars: 5,
                  img: "mauricio-perin",
                  imgAlt: "Mauricio Perin, Flach Equipamentos Inteligentes",
                },
                {
                  testimonial: <Fragment>"Hoje, com o Mercos, nosso time comercial fecha vendas e calcula orçamentos em tempo real, com agilidade, sem erros e em um só lugar. Já o time interno foca demandas mais estratégicas, já que não há mais retrabalho na digitação de pedidos"</Fragment>,
                  author: "Natália Costa",
                  company: "Vouga Decor",
                  stars: 5,
                  img: "natalia-costa",
                  imgAlt: "Natália Costa, Vouga Decor",
                },
                {
                  testimonial: <Fragment>"Com o e-commerce B2B, nossos clientes ampliam o mix de compras e nos veem como uma empresa mais atualizada e acessível. Utilizamos a plataforma de forma estratégica e aumentamos vendas, fidelização e a liberdade dos clientes de comprar a qualquer hora"</Fragment>,
                  author: "Eduarda Berwanger",
                  company: "Berwanger Abrasivos",
                  stars: 5,
                },
              ]}
            />
          </section>
          {/* FAQ Section */}
          <FAQV6 useSemanticHeadings />

          {/* Final CTA Section */}
          <FinalCTACard
            buttonVariant="white"
            title="+ 9 mil empresas já usam o sistema líder de mercado"
            description="Proteja suas políticas comerciais e deixe o Mercos automatizar sua operação de ponta a ponta, garantindo que cada venda siga as regras do seu negócio"
          />

          <NewFooter />
        </div>
      </Fragment>
    );
  }
}

export default withSiteData(NewHomev6);



// WEBPACK FOOTER //
// /usr/src/site-blog/src/containers/site/NewHomev6.jsx